import { MiniQuote, Testimonials } from "@/components/marketplace"
import type { TestimonialsSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"
import { itemAt } from "@/lib/helpers/array"

export const TestimonialsFeedSection = ({ section, context }: FeedSectionProps<TestimonialsSection>) => {
  const { eyebrow, title, sub, quotes, cta } = section.data
  if (quotes.length === 0) return null
  if (section.presentation.variant === "mini") {
    const quote = itemAt(quotes, 0)
    return (
      <SectionFrame section={section} context={context} gut>
        <MiniQuote name={quote.name} loc={quote.loc} text={quote.text} stars={quote.stars} />
      </SectionFrame>
    )
  }
  // The rail bleeds to the gutter itself (Reel inset), so it owns its header.
  return (
    <SectionFrame section={section} context={context} ownsHeader>
      <Testimonials
        eyebrow={eyebrow}
        title={title}
        sub={sub}
        quotes={quotes}
        cta={cta?.label}
        ctaHref={cta ? resolveFeedLink(cta.link, context.countryCode, context.page) : undefined}
      />
    </SectionFrame>
  )
}
